import es from 'vee-validate/dist/locale/es.json';

export default {
  messages: {
    ...es.messages,
    txHash: "El hash de la transacción no es válido",
    IPV4_6: "La dirección IP no es válida",
    required: "El campo es obligatorio",
    confirmed: "El campo no coincide",
    txAddress: "La dirección no es válida",
  },
  names: {
    email: "correo electrónico",
    password: "Contraseña",
  },
  fields: {
    password: {
      min: "{_field_} es demasiado corto, ¿quieres que te hackeen?",
    },
  },
};
